export enum HandleType {
  Image = 'image',
  Video = 'video',
  Audio = 'audio',
  ThreeDee = '3D',
  Text = 'text',
  Seed = 'seed',
  Mask = 'mask',
  Lora = 'lora',
  Number = 'number',
  Boolean = 'boolean',
  Array = 'array',
  KlingElement = 'kling-element',
  Keyframe = 'keyframe',
  Any = 'any',
}
